type Props = {
    on?: boolean;
    width?: number;
    height?: number;
    onColor?: string;
    offColor?: string;
};

/**
 * 7セグメント表示のコロンを表示する
 */
export default function SevenSegColon({
    on = true,
    width = 40,
    height = 220,
    onColor = '#111111',
    offColor = '#e5e7eb',
}: Props) {
    // レスポンシブ対応: 半径を高さに基づいて計算（大きくする）
    const radius = Math.max(4, height * 0.1);

    return (
        <svg
            width="100%"
            height="100%"
            viewBox={`0 0 ${width} ${height}`}
            preserveAspectRatio="xMidYMid meet"
            style={{ maxWidth: `${width}px`, maxHeight: `${height}px` }}
            className="mx-1"
        >
            <circle cx={width / 2} cy={height * 0.36} r={radius} fill={on ? onColor : offColor} />
            <circle cx={width / 2} cy={height * 0.64} r={radius} fill={on ? onColor : offColor} />
        </svg>
    );
}
